import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Paper from '@material-ui/core/Paper';
// import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Header from '../../components/Header';
// import UnregisteredSearchButton from '../../components/atoms/UnregisteredSearchButton';
import UnregisteredShopRegisterButton from '../../components/atoms/UnregisteredShopRegisterButton';
import UnregisterdShopTable from '../organisms/UnregisteredShopTable';
import ShopAdd from '../organisms/ShopAdd';
import GroupAddModal from '../organisms/GroupAddModal';
import MailSentDialog from '../../components/molecules/MailSentDialog';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { getPreShops, clearPreShopDetail } from '../../actions/PreShops';
// import ValidationText from '../../components/atoms/ValidationText';
import StepBackButton from '../../components/atoms/StepBackButton';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getAccounts } from '../../actions/Accounts';

const styles = theme => ({
  root: {
    backgroundColor: '#ffffff',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    padding: '2px 0px 10px 20px',
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  mainPaper: {
    position: 'relative',
    margin: 1,
    padding: 10
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  textField150: {
    padding: '0px 5px 0px 5px',
    width: '200px'
  },
  button: {
    margin: '5px 5px'
  },
  buttonGroupLeft: {
    textAlign: 'left',
    float: 'left'
  },
  buttonRight: {
    textAlign: 'right'
  },
  buttonGroupRight: {
    textAlign: 'right',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'left'
    }
  },
  modalMobile: {
    maxWidth: 375,
    margin: 'auto',
    padding: '5% 10px 5%'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getPreShops, clearPreShopDetail, getAccounts },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openMailSendModal', 'updateOpenMailSendModal', false),
  withState('openMailSent', 'updateOpenMailSent', false),
  withState('openShopAdd', 'updateOpenShopAdd', false),
  withState('openShopAddConfirm', 'updateOpenShopAddConfirm', false),
  withState('openGroupAdd', 'updateOpenGroupAdd', false),
  withState('openGroupAddConfirm', 'updateOpenGroupAddConfirm', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('status', 'setStatus', 0),
  withState('preShopName', 'setPreShopName', ''),
  withState('cityId', 'setCityId', ''),
  withState('address', 'setAddress', ''),
  withState('includeUnregisteredShop', 'setIncludeUnregisteredShop', true),
  withState('maxOutError', 'setMaxOutError', ''),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangePage: props => async (event, page, limit) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 100;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }

      const searchKey = {
        preShopName: props.preShopName,
        address: props.address,
        includeUnregisteredShop: props.includeUnregisteredShop,
        page,
        limit: limit || limitNum
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      props.setMaxOutError('');
      await props.actions
        .getPreShops(searchKey)
        .then(data => {
          if (data.payload.maxOut) {
            props.setMaxOutError(
              '検索範囲が広いため、一部の店舗のみ表示しています。\n該当店舗が見つからない場合は、条件を絞り込んで再度検索をお願いします。'
            );
          }
          props.updateOpenProgress(false);
          props.updateLoading(false);
          props.updateOpenTable(true);
        })
        .catch(() => {
          props.updateOpenProgress(false);
          props.updateLoading(false);
        });
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions
        .getAccounts({ cognitoUserId: '' })
        .then(async data => this.props.checkSession(data));
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    openTable,
    handleRedirect,
    handleChangePage,
    account,
    // updateOpenTable,
    openShopAdd,
    updateOpenShopAdd,
    openShopAddConfirm,
    updateOpenShopAddConfirm,
    openGroupAdd,
    updateOpenGroupAdd,
    openGroupAddConfirm,
    updateOpenGroupAddConfirm,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    setResultMessage,
    openMailSent,
    updateOpenMailSent,
    // preShopName,
    // setPreShopName,
    cityId,
    setCityId,
    address,
    // setAddress,
    includeUnregisteredShop,
    // maxOutError,
    // setMaxOutError,
    page,
    preshopname
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;

    const progress = {
      loading,
      updateLoading,
      openProgress,
      updateOpenProgress,
      resultMessage,
      setResultMessage
    };

    const rowsPerPage = document.getElementById('rowsPerPage');
    let limitNum = 100;
    if (rowsPerPage) {
      limitNum = rowsPerPage.textContent;
    }

    const searchKey = {
      preshopname,
      address,
      includeUnregisteredShop,
      page,
      limit: limitNum
    };

    // const searchAction = async () => {
    // updateOpenTable(true);
    // handleChangePage(null, 1, limitNum);
    // updateLoading(true);
    // updateOpenProgress(true);
    // setMaxOutError('');
    // await actions
    //   .getPreShops(searchKey)
    //   .then(data => {
    //     handleChangePage(null, 0);
    //     if (data.payload.maxOut) {
    //       setMaxOutError(
    //         '検索範囲が広いため、一部の店舗のみ表示しています。\n該当店舗が見つからない場合は、条件を絞り込んで再度検索をお願いします。'
    //       );
    //     }
    //     updateOpenProgress(false);
    //     updateLoading(false);
    //     updateOpenTable(true);
    //   })
    //   .catch(() => {
    //     updateOpenProgress(false);
    //     updateLoading(false);
    //   });
    // };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    const shopRegisterAction = async () => {
      await actions.clearPreShopDetail();
      updateOpenShopAdd(true);
    };
    const shopCancelAction = () => updateOpenShopAdd(false);
    const shopBackAction = () => updateOpenShopAddConfirm(false);
    const groupCancelAction = () => updateOpenGroupAdd(false);
    const groupBackAction = () => updateOpenGroupAddConfirm(false);
    const backAction = () => handleRedirect('/release_step');
    return (
      <div className={classes.root}>
        <Header />
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            店舗登録
          </Typography>
          <Typography color="textSecondary">
            「店舗登録」ボタンから、貴店舗の新規登録を進めてください。
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.searchForm}>
            {/* <div>
              <ValidationText message={maxOutError} />
            </div>
            <div>
              <TextField
                label="店舗名"
                placeholder="部分一致"
                type="search"
                className={classes.textField}
                margin="normal"
                value={preShopName}
                onChange={e => {
                  setPreShopName(e.target.value);
                }}
              />
              <TextField
                label="住所"
                placeholder="部分一致"
                type="search"
                className={classes.textField}
                margin="normal"
                value={address}
                onChange={e => {
                  setAddress(e.target.value);
                }}
              />
            </div>
            <div className={classes.buttonGroupLeft}>
              <UnregisteredSearchButton onClickAction={searchAction} />
            </div> */}
            <div className={classes.buttonGroupRight}>
              <span className={classes.buttonRight}>
                <UnregisteredShopRegisterButton
                  onClickAction={shopRegisterAction}
                />
              </span>
            </div>
          </div>
          {openTable && (
            <UnregisterdShopTable
              searchKey={searchKey}
              updateOpenShopAdd={updateOpenShopAdd}
              progress={progress}
              page={page}
              handleChangePage={handleChangePage}
              selectedPage={page}
            />
          )}
          <div>
            {isShop && !isReleased && (
              <div>
                <StepBackButton onClickAction={backAction} />
              </div>
            )}
          </div>

          <div>
            <Modal open={openShopAdd} className={classes.modalMobile}>
              <ShopAdd
                openShopAddConfirm={openShopAddConfirm}
                updateOpenShopAdd={updateOpenShopAdd}
                updateOpenShopAddConfirm={updateOpenShopAddConfirm}
                cancelAction={shopCancelAction}
                backAction={shopBackAction}
                progress={progress}
                shopId={account.shopId}
                email={account.email}
                groupDepositManage={account.groupDepositManage}
                paymentGroupType={account.paymentGroupType}
                cityId={cityId}
                setCityId={setCityId}
              />
            </Modal>
            <Modal open={openGroupAdd}>
              <GroupAddModal
                openGroupAddConfirm={openGroupAddConfirm}
                updateOpenGroupAdd={updateOpenGroupAdd}
                updateOpenGroupAddConfirm={updateOpenGroupAddConfirm}
                cancelAction={groupCancelAction}
                backAction={groupBackAction}
                cityId={cityId}
                setCityId={setCityId}
              />
            </Modal>
            <MailSentDialog
              openMailSent={openMailSent}
              updateOpenMailSent={updateOpenMailSent}
            />
          </div>
        </Paper>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
